<mat-form-field class="mat-form-field-sm"
                subscriptSizing="dynamic"
                appearance="outline">
  <mat-select [ngModel]="currentApplication?.id"
              (selectionChange)="onChangeApplication($event.value)">
    <ng-container *ngFor="let application of applications">
      <mat-option [value]="application?.id">
        {{ application?.applicationNumber }}
      </mat-option>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-select>
  <mat-hint> {{ currentApplication?.entityDBA || currentApplication?.entityName}}</mat-hint>
</mat-form-field>
